export default "__VITE_ASSET__DCQhRSlA__"